export default __webpack_public_path__ + "static/media/logo-round.cdc9f4c5.svg";